import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import Button from "@material-ui/core/Button";
import AutoForm from "react-auto-form";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

//import { ToastContainer, toast } from "react-toastify";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


export class O_MonitoringNoteSupplies extends Component {
    ////constructor(props) {
    ////    super(props);
    ////    this.state = {
    ////        lastOnChange: null,
    ////        lastOnSubmit: null,
    ////        trim: true,
    ////        trimOnSubmit: false
    ////    };
    ////}

    ////_onChange = (e, name, data, change) => {
    ////    console.log(data);
    ////    this.setState({ lastOnChange: { name, data, change } });
    ////};

    ////_onSubmit = (e, data) => {
    ////    console.log("submit");
    ////    console.log(data);
    ////    this.setState({ lastOnSubmit: { data } });
    ////    e.preventDefault();
    ////};

    ////_onOptionsChange = (e, name, data, change) => {
    ////    this.setState(change);
    ////};

    //constructor(props) {
    //    super(props);
    //    this.state = {
    //        projectId: props.propProjectId,
    //        lastOnChange: null,
    //        lastOnSubmit: null,
    //        trim: true,
    //        trimOnSubmit: false,
    //        pageLoadData: {}
    //    };
    //}

    //_onChange = (e, name, data, change) => {
    //    console.log(data);
    //    this.setState({ lastOnChange: { name, data, change } });
    //};

    //_onSubmit = (e, data) => {
    //    console.log("submit");
    //    //console.log(data);
    //    this.setState({ lastOnSubmit: { data } });

    //    let dataToSubmit = data;
    //    dataToSubmit["projectId"] = this.state.projectId;
    //    dataToSubmit["templateId"] = 3;
    //    console.log(dataToSubmit);

    //    fetch(global.variables.API_TEMPLATEFILLER_FILLANSWERS, {
    //        method: "POST",
    //        headers: {
    //            Authorization: "Bearer " + localStorage.getItem("authtoken"),
    //            Accept: "application/json",
    //            "Content-Type": "application/json"
    //        },
    //        body: JSON.stringify(dataToSubmit)
    //    })
    //        .then(response => response.json())
    //        .then(result => {
    //            console.log(result);
    //        });

    //    e.preventDefault();
    //};

    //_onOptionsChange = (e, name, data, change) => {
    //    console.log(data);
    //    this.setState(change);
    //};

    //async componentDidMount() {
    //    await fetch(global.variables.API_TEMPLATEFILLER_GETANSWERS, {
    //        method: "POST",
    //        headers: {
    //            Authorization: "Bearer " + localStorage.getItem("authtoken"),
    //            Accept: "application/json",
    //            "Content-Type": "application/json"
    //        },
    //        body: JSON.stringify({
    //            operation: "GetOnGoingMNoteSupplies",
    //            projectId: this.state.projectId,
    //            templateId: 3
    //        })
    //    })
    //        .then(response => response.json())
    //        .then(result => {
    //            console.log(result);

    //            if (result.saveddata.length > 0) {
    //                this.setState({ pageLoadData: JSON.parse(result.saveddata[0].TemplateAnswers) });
    //            }
    //        });

    //    //console.log(this.state.pageLoadData);
    //    //console.log(this.state.pageLoadData.OmrQ1Context);
    //    //this.forceUpdate();
    //}

    //render() {
    //    //let { lastOnChange, lastOnSubmit, trim, trimOnSubmit } = this.state;
    //    let { trim, trimOnSubmit } = this.state;


    constructor(props) {
        super(props);
        this.state = {
            missionId: props.propMissionId,
            lastOnChange: null,
            lastOnSubmit: null,
            trim: false,
            trimOnSubmit: false,
            pageLoadData: {},
            templateId: props.propTemplateId,
            countOtherDocuments: 1,
            countPerson: 1,
            interviewPersonCategories: [
                { TypeId: 1, TypeName: "Beneficiary" },
                { TypeId: 2, TypeName: "Partner Country" },
                { TypeId: 3, TypeName: "Stakeholder" },
                { TypeId: 4, TypeName: "Other" },
                { TypeId: 5, TypeName: "DEUA" },
                { TypeId: 6, TypeName: "EU Delegation" },
                { TypeId: 7, TypeName: "Contracting Authority" },
                { TypeId: 8, TypeName: "End Beneficiary" },
                { TypeId: 9, TypeName: "Lead Institution" },
                { TypeId: 10, TypeName: "Contractor" },
                { TypeId: 11, TypeName: "Final Beneficiary" },
            ],
        };
    }

    _onChange = (e, name, data, change) => {
        console.log(data)

        var pageLoadDataChange = this.state.pageLoadData;
        pageLoadDataChange[name] = data;

        this.setState({
            lastOnChange: { name, data, change },
            pageLoadData: pageLoadDataChange
        });

    }

    _onSubmit = (e, data) => {
        console.log("submit");
        this.setState({ lastOnSubmit: { data } });

        let dataToSubmit = data;
        dataToSubmit["missionId"] = this.state.missionId;
        dataToSubmit["templateId"] = this.state.templateId;
        dataToSubmit["countOtherDocuments"] = this.state.countOtherDocuments;
        dataToSubmit["countPerson"] = this.state.countPerson;
        console.log(dataToSubmit);

        this.props.propUpdatePageLoadData(dataToSubmit);

        fetch(global.variables.API_TEMPLATEFILLER_FILLANSWERS, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(dataToSubmit)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                } else {
                    toast.error("Failed!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }
            });

        e.preventDefault();
    }

    _onOptionsChange = (e, name, data, change) => {
        console.log(data);
        this.setState(change);
    };

    async componentDidMount() {
        await fetch(global.variables.API_TEMPLATEFILLER_GETANSWERS, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                operation: "GetExpostMq",
                missionId: this.state.missionId,
                templateId: this.state.templateId
            })
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.saveddata.length > 0) {
                    this.setState({ pageLoadData: JSON.parse(result.saveddata[0].TemplateAnswers) });

                    if (JSON.parse(result.saveddata[0].TemplateAnswers).countOtherDocuments !== undefined &&
                        JSON.parse(result.saveddata[0].TemplateAnswers).countOtherDocuments > 0) {
                        this.setState({
                            countOtherDocuments: JSON.parse(result.saveddata[0].TemplateAnswers).countOtherDocuments,
                        });
                    } else {
                        this.setState({
                            countOtherDocuments: 1,
                        });
                    }

                    if (JSON.parse(result.saveddata[0].TemplateAnswers).countPerson !== undefined &&
                        JSON.parse(result.saveddata[0].TemplateAnswers).countPerson > 0) {
                        this.setState({
                            countPerson: JSON.parse(result.saveddata[0].TemplateAnswers).countPerson,
                        });
                    } else {
                        this.setState({
                            countPerson: 1,
                        });
                    }
                }
            });

        this.props.propUpdatePageLoadData(this.state.pageLoadData);
    }

    checkIfChecked = (element, value) => {
        if (element === value) {
            return true;
        } else {
            return false;
        }
    };

    incrementOtherDocuments = () => {
        var countOtherDocuments = this.state.countOtherDocuments;

        if (countOtherDocuments < 20) {
            countOtherDocuments += 1;
        }

        this.setState({ countOtherDocuments: countOtherDocuments });
    }

    incrementPerson = () => {
        var countPerson = this.state.countPerson;

        if (countPerson < 20) {
            countPerson += 1;
        }

        this.setState({ countPerson: countPerson });
    }

    handleSelectChange = async (e, v, vname) => {
        e.persist();

        if (v !== undefined & v !== null) {
            await this.setState({ [vname]: v.TypeId });
        } else {
            await this.setState({ [vname]: -1 });
        }

        //console.log(vname + ": " + e.target.value);
        console.log(this.state);
    }

    handleSelectChangeUseValue = async (e, v, vname) => {
        e.persist();

        //console.log(data)
        //this.setState({ lastOnChange: { name, data, change } })

        var pageLoadDataChange = this.state.pageLoadData;
        //pageLoadDataChange[vname] = v.TypeName;
        if (v !== undefined & v !== null) {
            pageLoadDataChange[vname] = v.TypeId;
        } else {
            pageLoadDataChange[vname] = -1;
        }

        this.setState({
            //lastOnChange: { name, data, change },
            pageLoadData: pageLoadDataChange
        });

        //if (v !== undefined & v !== null) {
        //    await this.setState({ [vname]: v.TypeName });
        //} else {
        //    await this.setState({ [vname]: "" });
        //}

        console.log(this.state);
    }

    handleSelectChangePageLoadData = async (e, v, vname) => {

        //console.log("handleSelectChangePageLoadData vId: " + v.TypeId + " vName: " + v.TypeName + " vname: " + vname);

        e.persist();

        //console.log(data)
        //this.setState({ lastOnChange: { name, data, change } })

        var pageLoadDataChange = this.state.pageLoadData;
        //pageLoadDataChange[vname] = v.TypeName;
        if (v !== undefined & v !== null) {
            //pageLoadDataChange[vname] = v.TypeId;
            pageLoadDataChange[vname] = v.TypeName;
        } else {
            pageLoadDataChange[vname] = -1;
        }

        this.setState({
            //lastOnChange: { name, data, change },
            pageLoadData: pageLoadDataChange
        });

        console.log(this.state);
    }

    returnArrayElement = (array, element) => {
        for (var i = 0; i < array.length; i++) {
            if (array[i].TypeId === element) {
                return array[i];
            }
        }

        return ({ TypeId: "", TypeName: "" });
    };

    returnArrayElementUseValue = (array, element) => {
        for (var i = 0; i < array.length; i++) {
            if (array[i].TypeName === element) {
                return array[i];
            }
        }

        return ({ TypeId: "", TypeName: "" });
    };

    render() {
        let {
            trim,
            trimOnSubmit,
            pageLoadData,
            countOtherDocuments,
            countPerson,
            interviewPersonCategories,
        } = this.state;
        return (
            <Grid container>
                <AutoForm
                    onSubmit={this._onSubmit}
                    onChange={this._onChange}
                    trim={!!trim}
                    trimOnSubmit={!!trimOnSubmit}
                    style={{ width: "100%" }}
                >
                    <Grid item xs={12}>
                        <p>Scoring</p>
                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>Relevance</Typography>
                            </ExpansionPanelSummary>
                            {
                                //<ExpansionPanelDetails>
                                //    <Grid item xs container direction="column" spacing={2}>
                                //        <TextareaAutosize name="OmsS1Relevance" rows={6} defaultValue={this.state.pageLoadData.OmsS1Relevance} />
                                //    </Grid>
                                //</ExpansionPanelDetails>
                            }
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmsS1Relevance" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmsS1Relevance, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmsS1Relevance, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmsS1Relevance, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>Efficiency</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmsS2Efficiency" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmsS2Efficiency, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmsS2Efficiency, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmsS2Efficiency, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>Effectiveness</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmsS3Effectiveness" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmsS3Effectiveness, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmsS3Effectiveness, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmsS3Effectiveness, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        {
                            //<ExpansionPanel style={{ width: "50%" }}>
                            //    <ExpansionPanelSummary
                            //        expandIcon={<ExpandMoreIcon />}
                            //        aria-controls="panel1a-content"
                            //        id="panel1a-header"
                            //    >
                            //        <Typography>Impact</Typography>
                            //    </ExpansionPanelSummary>
                            //    <ExpansionPanelDetails>
                            //        <RadioGroup aria-label="gender" name="OmsS4Impact" >
                            //            <Grid item xs direction="column">
                            //                <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmsS4Impact, "1")} control={<Radio />} className="green" />
                            //                <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmsS4Impact, "2")} control={<Radio />} className="orange" />
                            //                <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmsS4Impact, "3")} control={<Radio />} className="red" />
                            //            </Grid>
                            //        </RadioGroup>
                            //    </ExpansionPanelDetails>
                            //</ExpansionPanel>
                        }

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>Sustainability</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmsS5Sustainability" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmsS5Sustainability, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmsS5Sustainability, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmsS5Sustainability, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        {
                            //<Card>
                            //    <CardContent>
                            //        <Grid container>
                            //            <Grid item xs={3}>

                            //                <Typography>Sustainability</Typography>
                            //            </Grid>

                            //            <Grid item xs={3}>

                            //                <RadioGroup aria-label="gender" name="OmsS5Sustainability" >
                            //                    <Grid item xs direction="column">
                            //                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmsS5Sustainability, "1")} control={<Radio />} className="green" />
                            //                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmsS5Sustainability, "2")} control={<Radio />} className="orange" />
                            //                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmsS5Sustainability, "3")} control={<Radio />} className="red" />
                            //                    </Grid>
                            //                </RadioGroup>

                            //            </Grid>
                            //            <Grid item xs={3} style={{ verticalAlign: 'middle' }}>

                            //                <Typography style={{ verticalAlign: 'middle' }}>Sustainability</Typography>
                            //            </Grid>

                            //            <Grid item xs={3}>

                            //                <FormControl component="fieldset">
                            //                    <FormLabel component="legend">Sustainability</FormLabel>
                            //                    <RadioGroup aria-label="gender" name="OmsS5Sustainability" >
                            //                        <Grid item xs direction="column">
                            //                            <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmsS5Sustainability, "1")} control={<Radio />} className="green" />
                            //                            <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmsS5Sustainability, "2")} control={<Radio />} className="orange" />
                            //                            <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmsS5Sustainability, "3")} control={<Radio />} className="red" />
                            //                        </Grid>
                            //                    </RadioGroup>
                            //                </FormControl>


                            //                <RadioGroup aria-label="gender" name="OmsS5Sustainability" >
                            //                    <Grid item xs direction="column">
                            //                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmsS5Sustainability, "1")} control={<Radio />} className="green" />
                            //                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmsS5Sustainability, "2")} control={<Radio />} className="orange" />
                            //                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmsS5Sustainability, "3")} control={<Radio />} className="red" />
                            //                    </Grid>
                            //                </RadioGroup>


                            //            </Grid>
                            //        </Grid>
                            //    </CardContent>
                            //</Card>
                        }

                        <br />
                        <p>1. Relevance</p>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>
                                    1.1 Are the supplies identified in the supply contact meeting the needs of the target groups / end beneficiaries?
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmsQ1Are"
                                        rows={6}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmsQ1Are}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>
                                    1.2 Is the beneficiary involved in the definition of the supplies?
                                </Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmsQ2Is"
                                        rows={6}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmsQ2Is}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>1.3 Define the type of supplies to be provided.</Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmsQ3Define"
                                        rows={6}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmsQ3Define}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>1.4a Have indicators been defined to measure the delivery of the supplies?</Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmsQ17Have"
                                        rows={6}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmsQ17Have}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>
                                    1.4b Are all related data available on the tendering, evaluation and provision of supplies?
                                </Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmsQ4Are"
                                        rows={6}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmsQ4Are}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <br />
                        <p>2. Efficiency</p>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>
                                    2.1 Do the supplies funded correspond to the needs of the action?
                                </Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmsQ5Does"
                                        rows={6}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmsQ5Does}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>
                                    2.2 Has there been delays and how important are they and what are the consequences on the project?
                                </Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmsQ7Has"
                                        rows={6}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmsQ7Has}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>
                                    2.3 What are the reasons for the delays and to what extent have appropriate corrective measures been implemented?
                                </Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmsQ8What"
                                        rows={6}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmsQ8What}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>


                        <br />
                        <p>3. Effectiveness</p>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>
                                    3.1 How satisfactory is the quality of the supplies in relation to target groups?
                                </Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmsQ9How"
                                        rows={6}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmsQ9How}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <br />
                        <p>4. Sustainability</p>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>
                                    4.1 Are key stakeholders acquiring the necessary skills to benefit from the supplies’ component?
                                </Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmsQ10Are"
                                        rows={6}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmsQ10Are}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>
                                    4.2 Is access to the benefits affordable for target groups in the long term?
                                </Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmsQ11Is"
                                        rows={6}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmsQ11Is}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>
                                    4.3 Have the relevant authorities taken the financial measure(s) to ensure continuity of maintaining the supplies component at the end of the intervention?
                                </Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmsQ12Have"
                                        rows={6}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmsQ12Have}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>
                                    4.4 Has the private sector been involved in any stage of the supply component?  If so, please state involvement.
                                </Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmsQ13Has"
                                        rows={6}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmsQ13Has}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>
                                    4.5 Have the necessary measures been taken to address the environmental sustainability?
                                </Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmsQ14Have"
                                        rows={6}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmsQ14Have}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>


                        <br />
                        <p>5. Horizontal</p>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>
                                    5.1 Have the communication and visibility actions been implemented in an appropriate manner?
                                </Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmsQ15Have"
                                        rows={6}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmsQ15Have}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>
                                    5.2 Is the supplies component in line with the requirements of the other components of the current project (if applicable)?
                                </Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="OmsQ16Is"
                                        rows={6}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.OmsQ16Is}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>





                        <br />
                        <br />
                        <p><b>Sources of Information: List all documents analysed</b></p>
                        <p>Essential Project/Programme documents</p>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Action Documents</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmsC1ProjectDocuments" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmsC1ProjectDocuments, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmsC1ProjectDocuments, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmsC1ProjectDocuments, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Financing/Contribution/Delegation/Administration Agreement or grant contract</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                In these documents, all annexes are to be included such as Technical and Administrative provisions, Implementation schedule, logframe (incl. updates)
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmsC2FinancingContribution" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmsC2FinancingContribution, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmsC2FinancingContribution, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmsC2FinancingContribution, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Riders to all the documents listed above and their explanatory notes</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmsC3Riders" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmsC3Riders, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmsC3Riders, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmsC3Riders, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Annual and overall activity schedules/implementation plans</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmsC4Annual" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmsC4Annual, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmsC4Annual, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmsC4Annual, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Implementation progress reports</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="OmsC5Implementation" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.OmsC5Implementation, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.OmsC5Implementation, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.OmsC5Implementation, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>


                        <br />
                        <p>Other Documents</p>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography>Other Documents</Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 0 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmsOtherDocumentsD1" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 0 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmsOtherDocumentsD1} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 1 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmsOtherDocumentsD2" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 1 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmsOtherDocumentsD2} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 2 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmsOtherDocumentsD3" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 2 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmsOtherDocumentsD3} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 3 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmsOtherDocumentsD4" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 3 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmsOtherDocumentsD4} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 4 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmsOtherDocumentsD5" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 4 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmsOtherDocumentsD5} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 5 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmsOtherDocumentsD6" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 5 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmsOtherDocumentsD6} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 6 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmsOtherDocumentsD7" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 6 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmsOtherDocumentsD7} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 7 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmsOtherDocumentsD8" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 7 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmsOtherDocumentsD8} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 8 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmsOtherDocumentsD9" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 8 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmsOtherDocumentsD9} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 9 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmsOtherDocumentsD10" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 9 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmsOtherDocumentsD10} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 10 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmsOtherDocumentsD11" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 10 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmsOtherDocumentsD11} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 11 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmsOtherDocumentsD12" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 11 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmsOtherDocumentsD12} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 12 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmsOtherDocumentsD13" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 12 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmsOtherDocumentsD13} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 13 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmsOtherDocumentsD14" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 13 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmsOtherDocumentsD14} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 14 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmsOtherDocumentsD15" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 14 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmsOtherDocumentsD15} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 15 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmsOtherDocumentsD16" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 15 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmsOtherDocumentsD16} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 16 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmsOtherDocumentsD17" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 16 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmsOtherDocumentsD17} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 17 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmsOtherDocumentsD18" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 17 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmsOtherDocumentsD18} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 18 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmsOtherDocumentsD19" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 18 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmsOtherDocumentsD19} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 19 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="OmsOtherDocumentsD20" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 19 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.OmsOtherDocumentsD20} />
                                </Grid>
                            </ExpansionPanelDetails>

                            <ExpansionPanelDetails>
                                <Grid item xs>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={this.incrementOtherDocuments.bind(this)}
                                    >
                                        Add Documents
                                </Button>
                                </Grid>
                            </ExpansionPanelDetails>

                        </ExpansionPanel>


                        <br />
                        <p><b>Sources of Information: List of persons interviewed</b></p>

                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography>List Of Persons Interviewed</Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails style={{ display: countPerson > 0 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmsSOIP1PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmsSOIP1PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmsSOIP1PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP1PersonName"
                                    value={pageLoadData.OmsSOIP1PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP1PersonEmail"
                                    value={pageLoadData.OmsSOIP1PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP1PersonPosition"
                                    value={pageLoadData.OmsSOIP1PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP1PersonInstitution"
                                    value={pageLoadData.OmsSOIP1PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 1 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmsSOIP2PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmsSOIP2PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmsSOIP2PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP2PersonName"
                                    value={pageLoadData.OmsSOIP2PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP2PersonEmail"
                                    value={pageLoadData.OmsSOIP2PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP2PersonPosition"
                                    value={pageLoadData.OmsSOIP2PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP2PersonInstitution"
                                    value={pageLoadData.OmsSOIP2PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 2 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmsSOIP3PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmsSOIP3PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmsSOIP3PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP3PersonName"
                                    value={pageLoadData.OmsSOIP3PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP3PersonEmail"
                                    value={pageLoadData.OmsSOIP3PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP3PersonPosition"
                                    value={pageLoadData.OmsSOIP3PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP3PersonInstitution"
                                    value={pageLoadData.OmsSOIP3PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 3 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmsSOIP4PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmsSOIP4PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmsSOIP4PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP4PersonName"
                                    value={pageLoadData.OmsSOIP4PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP4PersonEmail"
                                    value={pageLoadData.OmsSOIP4PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP4PersonPosition"
                                    value={pageLoadData.OmsSOIP4PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP4PersonInstitution"
                                    value={pageLoadData.OmsSOIP4PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 4 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmsSOIP5PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmsSOIP5PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmsSOIP5PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP5PersonName"
                                    value={pageLoadData.OmsSOIP5PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP5PersonEmail"
                                    value={pageLoadData.OmsSOIP5PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP5PersonPosition"
                                    value={pageLoadData.OmsSOIP5PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP5PersonInstitution"
                                    value={pageLoadData.OmsSOIP5PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 5 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmsSOIP6PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmsSOIP6PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmsSOIP6PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP6PersonName"
                                    value={pageLoadData.OmsSOIP6PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP6PersonEmail"
                                    value={pageLoadData.OmsSOIP6PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP6PersonPosition"
                                    value={pageLoadData.OmsSOIP6PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP6PersonInstitution"
                                    value={pageLoadData.OmsSOIP6PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 6 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmsSOIP7PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmsSOIP7PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmsSOIP7PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP7PersonName"
                                    value={pageLoadData.OmsSOIP7PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP7PersonEmail"
                                    value={pageLoadData.OmsSOIP7PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP7PersonPosition"
                                    value={pageLoadData.OmsSOIP7PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP7PersonInstitution"
                                    value={pageLoadData.OmsSOIP7PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 7 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmsSOIP8PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmsSOIP8PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmsSOIP8PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP8PersonName"
                                    value={pageLoadData.OmsSOIP8PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP8PersonEmail"
                                    value={pageLoadData.OmsSOIP8PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP8PersonPosition"
                                    value={pageLoadData.OmsSOIP8PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP8PersonInstitution"
                                    value={pageLoadData.OmsSOIP8PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 8 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmsSOIP9PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmsSOIP9PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmsSOIP9PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP9PersonName"
                                    value={pageLoadData.OmsSOIP9PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP9PersonEmail"
                                    value={pageLoadData.OmsSOIP9PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP9PersonPosition"
                                    value={pageLoadData.OmsSOIP9PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP9PersonInstitution"
                                    value={pageLoadData.OmsSOIP9PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 9 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmsSOIP10PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmsSOIP10PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmsSOIP10PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP10PersonName"
                                    value={pageLoadData.OmsSOIP10PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP10PersonEmail"
                                    value={pageLoadData.OmsSOIP10PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP10PersonPosition"
                                    value={pageLoadData.OmsSOIP10PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP10PersonInstitution"
                                    value={pageLoadData.OmsSOIP10PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 10 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmsSOIP11PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmsSOIP11PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmsSOIP11PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP11PersonName"
                                    value={pageLoadData.OmsSOIP11PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP11PersonEmail"
                                    value={pageLoadData.OmsSOIP11PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP11PersonPosition"
                                    value={pageLoadData.OmsSOIP11PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP11PersonInstitution"
                                    value={pageLoadData.OmsSOIP11PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 11 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmsSOIP12PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmsSOIP12PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmsSOIP12PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP12PersonName"
                                    value={pageLoadData.OmsSOIP12PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP12PersonEmail"
                                    value={pageLoadData.OmsSOIP12PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP12PersonPosition"
                                    value={pageLoadData.OmsSOIP12PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP12PersonInstitution"
                                    value={pageLoadData.OmsSOIP12PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 12 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmsSOIP13PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmsSOIP13PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmsSOIP13PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP13PersonName"
                                    value={pageLoadData.OmsSOIP13PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP13PersonEmail"
                                    value={pageLoadData.OmsSOIP13PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP13PersonPosition"
                                    value={pageLoadData.OmsSOIP13PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP13PersonInstitution"
                                    value={pageLoadData.OmsSOIP13PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 13 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmsSOIP14PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmsSOIP14PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmsSOIP14PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP14PersonName"
                                    value={pageLoadData.OmsSOIP14PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP14PersonEmail"
                                    value={pageLoadData.OmsSOIP14PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP14PersonPosition"
                                    value={pageLoadData.OmsSOIP14PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP14PersonInstitution"
                                    value={pageLoadData.OmsSOIP14PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 14 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmsSOIP15PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmsSOIP15PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmsSOIP15PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP15PersonName"
                                    value={pageLoadData.OmsSOIP15PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP15PersonEmail"
                                    value={pageLoadData.OmsSOIP15PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP15PersonPosition"
                                    value={pageLoadData.OmsSOIP15PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP15PersonInstitution"
                                    value={pageLoadData.OmsSOIP15PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 15 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmsSOIP16PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmsSOIP16PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmsSOIP16PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP16PersonName"
                                    value={pageLoadData.OmsSOIP16PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP16PersonEmail"
                                    value={pageLoadData.OmsSOIP16PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP16PersonPosition"
                                    value={pageLoadData.OmsSOIP16PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP16PersonInstitution"
                                    value={pageLoadData.OmsSOIP16PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 16 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmsSOIP17PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmsSOIP17PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmsSOIP17PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP17PersonName"
                                    value={pageLoadData.OmsSOIP17PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP17PersonEmail"
                                    value={pageLoadData.OmsSOIP17PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP17PersonPosition"
                                    value={pageLoadData.OmsSOIP17PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP17PersonInstitution"
                                    value={pageLoadData.OmsSOIP17PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 17 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmsSOIP18PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmsSOIP18PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmsSOIP18PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP18PersonName"
                                    value={pageLoadData.OmsSOIP18PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP18PersonEmail"
                                    value={pageLoadData.OmsSOIP18PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP18PersonPosition"
                                    value={pageLoadData.OmsSOIP18PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP18PersonInstitution"
                                    value={pageLoadData.OmsSOIP18PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 18 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmsSOIP19PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmsSOIP19PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmsSOIP19PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP19PersonName"
                                    value={pageLoadData.OmsSOIP19PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP19PersonEmail"
                                    value={pageLoadData.OmsSOIP19PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP19PersonPosition"
                                    value={pageLoadData.OmsSOIP19PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP19PersonInstitution"
                                    value={pageLoadData.OmsSOIP19PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 19 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "OmsSOIP20PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.OmsSOIP20PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="OmsSOIP20PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP20PersonName"
                                    value={pageLoadData.OmsSOIP20PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP20PersonEmail"
                                    value={pageLoadData.OmsSOIP20PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP20PersonPosition"
                                    value={pageLoadData.OmsSOIP20PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="OmsSOIP20PersonInstitution"
                                    value={pageLoadData.OmsSOIP20PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>

                            <ExpansionPanelDetails>
                                <Grid item xs>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={this.incrementPerson.bind(this)}
                                    >
                                        Add Person
                                </Button>
                                </Grid>
                            </ExpansionPanelDetails>

                        </ExpansionPanel>





                    </Grid>
                    <Grid item xs={12} style={{ textAlign: "center" }} className="mt-1">
                        <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                        >
                            SAVE
            </Button>
                    </Grid>
                </AutoForm>
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/O_MonitoringNoteSupplies.js